import { Pipe, PipeTransform } from '@angular/core';
import { Trip } from '../api/commonInterfaces';
import { ConfigService } from '../config.service';

@Pipe({
    name: 'tripJournalLink',
})
export class TripJournalLinkPipe implements PipeTransform {

  constructor(
    private config: ConfigService
  ) {}

  transform(value: number | Trip): string {
    let tripId: number = 0
    
    if (typeof value === "object") {
      tripId = value.id
    }
    else {
      tripId = value
    }

    return `${this.config.mainSiteUrl}/mission-trip-journals/${tripId}`
  }

}
